import {
  all, fork
} from 'redux-saga/effects'

import watchers from './watchers'

export default function * coreSaga () {
  yield all(watchers.map((watcher) => fork(watcher)))
}